import React from 'react';
import s from './s.module.less';
import BenefitIcon from '../imgs/benefit-icon.svg';

const BENEFITS_DATA = [
    {
        key: 'secure',
        title: 'Easy, secure & HIPAA compliant faxing',
        items: [
            'Securely transmit protected health information between clinicians, pharmacies, labs, hospitals, and insurance organizations.',
            'Send notes, treatment plans, prior authorizations, lab orders, referrals, and other necessary documents.',
            'Receive faxes to your dedicated fax number — no physical machine required.',
            'Automatically save faxes to the correct patient record.',
            'Keep everything secure and HIPAA compliant.',
        ],
    },
    {
        key: 'ai',
        title: 'Smart AI that organizes your faxes',
        items: [
            'Smart document summaries for a quick overview of each fax',
            'Automatic document tagging to identify lab results, referrals, prior authorizations, and pharmacy requests',
            'Automatic client matching to route faxes to the correct client record',
        ],
    },
    {
        key: 'pricing',
        title: 'Transparent pricing — $9.9 / month per fax number',
        items: [
            'Dedicated fax number',
            '250 pages per month wth $0.08/additional page beyond the 250 page limit',
            'Inbound & outbound faxing',
            'AI-assisted features',
            'Status tracking & retry',
        ],
    },
];

const Benefits = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.sectionTitle}>Why choose Klarity eFax</h2>
            <div className={s.cardList}>
                {BENEFITS_DATA.map((benefit) => (
                    <div className={s.card} key={benefit.key}>
                        <div className={s.cardHeader}>
                            <div className={s.iconWrap}>
                                <img src={BenefitIcon} alt="" aria-hidden />
                            </div>
                            <span className={s.cardTitle}>{benefit.title}</span>
                        </div>
                        <div className={s.listWrap}>
                            <ul className={s.itemList}>
                                {benefit.items.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Benefits;
